import React from 'react';
import ReactDOM from 'react-dom/client';
import { msalInstance } from './auth/msalConfig';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Initialize MSAL and handle any redirect BEFORE React renders.
// This avoids race conditions with MsalProvider + StrictMode.
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then((response) => {
  // If returning from a redirect, set the account as active
  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  }

  // If no active account but cached accounts exist, set the first one active
  if (!msalInstance.getActiveAccount()) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  const activeAccount = msalInstance.getActiveAccount();
  if (activeAccount) {
    console.log('MSAL init complete. Active account:', activeAccount.username);
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}).catch((error) => {
  console.error('MSAL initialization failed:', error);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});